import React, { useState } from 'react';
import { auth } from '../lib/supabase';

export default function Auth() {
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async () => {
    if (!email || !password) return;
    setLoading(true);
    setMessage(null);
    const { error } = isSignup
      ? await auth.signUp(email, password)
      : await auth.signIn(email, password);
    if (error) {
      setMessage({ type: 'error', text: error.message });
    } else if (isSignup) {
      setMessage({ type: 'success', text: 'Compte créé ! Vérifie tes emails pour confirmer, puis reviens te connecter.' });
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
      <div
        className="fixed inset-0 pointer-events-none opacity-[0.015]"
        style={{
          backgroundImage: 'linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}
      />
      <div className="relative w-full max-w-md">

        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 border-2 border-cyan-400 rotate-45 flex items-center justify-center">
            <div className="w-5 h-5 bg-cyan-400 -rotate-45" />
          </div>
          <div>
            <div className="font-black text-3xl tracking-widest leading-none">
              APEX <span className="text-cyan-400">Climber</span>
            </div>
            <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase mt-1">ADC Climb Tracker · EUW</div>
          </div>
        </div>

        {/* Form */}
        <div className="border border-zinc-800 bg-zinc-950 p-8">
          <div className="text-[10px] tracking-[0.3em] text-zinc-500 uppercase font-semibold mb-6 text-center">
            {isSignup ? 'Créer un compte' : 'Connexion'}
          </div>
          <div className="space-y-4">
            <div>
              <label className="text-[10px] text-zinc-600 font-mono tracking-wider uppercase">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-zinc-900 border border-zinc-800 text-white p-3 mt-1 focus:border-cyan-400 focus:outline-none"
                placeholder="nabousan@exemple.com"
              />
            </div>
            <div>
              <label className="text-[10px] text-zinc-600 font-mono tracking-wider uppercase">Mot de passe</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                className="w-full bg-zinc-900 border border-zinc-800 text-white p-3 mt-1 focus:border-cyan-400 focus:outline-none"
                placeholder="••••••••"
              />
            </div>
            {message && (
              <div className={`p-3 text-xs border ${message.type === 'error' ? 'border-rose-400/30 text-rose-400 bg-rose-400/5' : 'border-cyan-400/30 text-cyan-400 bg-cyan-400/5'}`}>
                {message.text}
              </div>
            )}
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="w-full bg-cyan-400 text-black p-3 font-black tracking-wider hover:bg-cyan-300 transition disabled:opacity-50"
            >
              {loading ? 'CHARGEMENT...' : (isSignup ? "S'INSCRIRE" : 'SE CONNECTER')}
            </button>
            <button
              onClick={() => { setIsSignup(!isSignup); setMessage(null); }}
              className="w-full text-xs text-zinc-500 hover:text-zinc-300 transition tracking-wider uppercase"
            >
              {isSignup ? "J'ai déjà un compte" : 'Créer un compte'}
            </button>
          </div>
        </div>

        {/* Footer légal */}
        <div className="flex items-center justify-center gap-4 mt-6 text-[10px] text-zinc-600 tracking-[0.15em] uppercase">
          <a href="#/privacy" className="hover:text-zinc-400 transition">Confidentialité</a>
          <span className="text-zinc-800">·</span>
          <a href="#/terms" className="hover:text-zinc-400 transition">CGU</a>
          <span className="text-zinc-800">·</span>
          <span>Not affiliated with Riot Games</span>
        </div>

      </div>
    </div>
  );
}
